import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND, FOOTER, COLORS } from '../../data/siteData';
import { MapPin, Phone, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="py-12" style={{ backgroundColor: COLORS.dark }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Logo and Brand */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src={BRAND.logo} 
                alt={BRAND.name} 
                className="h-10 w-auto"
              />
              <span className="text-xl text-white font-bold">
                {BRAND.name}<span style={{ color: COLORS.red }}>®</span>
              </span>
            </div>
            <p className="text-sm text-white/60 mb-4">
              Knygomatai.lt yra įgyvendinta
            </p>
            <p className="text-white font-semibold">
              0g Baltics UAB
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white font-semibold mb-4">Apie mus</h4>
            <nav className="flex flex-col space-y-2">
              {FOOTER.links.map((link, index) => (
                link.href.startsWith('/') ? (
                  <Link
                    key={index}
                    to={link.href}
                    className="text-sm text-white/70 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                ) : (
                  <a
                    key={index}
                    href={link.href}
                    className="text-sm text-white/70 hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                )
              ))}
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Kontaktai</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="w-4 h-4 text-white/60 mt-0.5 flex-shrink-0" />
                <p className="text-sm text-white/70">
                  A. Goštauto g. 8-358<br />
                  LT-01108 Vilnius
                </p>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-4 h-4 text-white/60 flex-shrink-0" />
                <a 
                  href="tel:+37068204909" 
                  className="text-sm text-white/70 hover:text-white transition-colors"
                >
                  +370 682 04909
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-4 h-4 text-white/60 flex-shrink-0" />
                <a 
                  href="mailto:info@0gbaltics.com" 
                  className="text-sm text-white/70 hover:text-white transition-colors"
                >
                  info@0gbaltics.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-white/50 mb-4 md:mb-0">
              {FOOTER.copyright}
            </p>
            <p className="text-xs text-white/40">
              Knygomatai® yra registruotas prekės ženklas
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
